import React from "react";
import StringInput from "../../../formElements/StringInput";
import FreeTypeSelectInput from "../../../formElements/FreeTypeSelectInput";
import DateInput from "../../../formElements/DateInput";
import TwoColumnRows from "../../../formElements/TwoColumnRows";
import {Card} from "react-bootstrap";
import PopupWarning from "../../../../dialogs/PopupWarning";
import {useModal} from "../../../../dialogs/ModalContext";

function NewInstrumentSelector(props) {
    const {showModal} = useModal();
    const [instrumentData, setInstrumentData] = React.useState({
        SNR: "",
        Produkt: "",
        Datum_Vyroby: null,
        Zaruka: null,
        Poznamka: "",
        Demo: false
    })

    function updateInstrument(event) {
        let newData = {...instrumentData}
        newData[event.target.name] = event.target.value
        setInstrumentData(newData)
    }

    function addInstrument() {
        if (instrumentData.SNR === "") {
            showModal(PopupWarning, "Parameter \"SNR\" je povinný.", () => {});
            return
        } else if (instrumentData.Produkt === "") {
            showModal(PopupWarning, "Parameter \"Produkt\" je povinný.", () => {});
            return
        }
        props.addInstrument(instrumentData)
        setInstrumentData({
            SNR: "",
            Produkt: "",
            Datum_Vyroby: null,
            Zaruka: null,
            Poznamka: "",
            Demo: false
        })
    }

    function getProductOptions() {
        let options = props.products.map(item => item.Typ)
        if (options) {
            options = options.sort((a, b) => a.localeCompare(b))
        }
        return options ? ['', ...options] : []
    }

    return (
        <div>
            <Card border={"muted"} bg={"light"} style={{marginTop: '10px'}}>
                <div className="m-lg-3">
                    <TwoColumnRows>
                        <StringInput name={'SNR'} label={'SNR'} value={instrumentData.SNR} onChange={updateInstrument}/>
                        <FreeTypeSelectInput options={getProductOptions()} name={'Produkt'} label={'Produkt'}
                                             value={instrumentData.Produkt} onChange={updateInstrument}/>
                        <DateInput name={'Datum_Vyroby'} label={'Dátum Výroby'} value={instrumentData.Datum_Vyroby}
                                   onChange={updateInstrument}/>
                        <DateInput name={'Zaruka'} label={'Záruka'} value={instrumentData.Zaruka}
                                   onChange={updateInstrument}/>
                        <StringInput name={'Poznamka'} label={'Poznámka'} value={instrumentData.Poznamka}
                                     onChange={updateInstrument}/>
                    </TwoColumnRows>
                    <button type="button" className="btn btn-outline-primary btn-md humongousButton" style={{margin:0}} onClick={addInstrument}>Pridať
                        prístroj
                    </button>
                </div>
            </Card>
        </div>
    )
}

export default NewInstrumentSelector
